import Popover from './Popover';

export default Popover;



// WEBPACK FOOTER //
// ./src/components/popover/index.js